import { Button } from "PFComponents/button";
import { Activity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./cancel_button.module.scss";

type CancelButtonProps = {
  activity: Activity;
  handleEngagementWizardNavigation: (activity: Activity, options: Record<string, any>) => void;
  engagementWizardState?: object;
  isRole: boolean;
};

export const CancelButton = ({
  activity,
  handleEngagementWizardNavigation,
  engagementWizardState,
  isRole
}: CancelButtonProps) => {
  const { t } = useTranslation("translation");
  const history = useHistory();

  const handleCancel = () => {
    if (isRole && engagementWizardState) {
      handleEngagementWizardNavigation(activity, { cancel: true });
    } else {
      history.goBack();
    }
  };

  return <Button kind="secondary" text={t("cancel")} onClick={handleCancel} className={css.cancelButton} />;
};
